// extracted by mini-css-extract-plugin
module.exports = {"sticky-submit":"styles_sticky-submit__94omL","sticky-submit__content-container":"styles_sticky-submit__content-container__WE8yK"};